import PrivacyRoute from "../../components/routes/PrivacyRoute";
import messages from "../../i18n/messages/fr.json";

export default function Page() {
  return <PrivacyRoute locale="fr" messages={messages} />;
}
